import { get, post, uploadFile, downloadFile } from '@/http/axios';

// 根据vin获取车辆详细信息
export function getVehicleInfoByVin(vin) {
  return post({
    url: `/tsp-jsatl/fms/jsatl/alarm/params/vehicleInfo`,///tsp-jsatl/fms/jsatl/alarm/params/vehicleInfo
    data: {"vinList":[vin]}
  });
}
/**
 * 可视化联调-报警参数查询
 */
export function getQueryAlarm(params) {
  console.log("para",params);
  return get({
    url: '/tsp-jsatl/jsatl/alarm/params/query_params',
    params
  });
}
/**
 * 可视化联调-新建任务
 */
export function addTaskShort(params) {
  return post({
    url: '/tsp-jsatl/jsatl/alarm/params/addTaskShort',
    data:params
  });
}
export function alarmHexPage(params) {
  return get({
    url: '/tsp-jsatl/fms/jsatl/alarm/hex/page',
    params
  });
}

export function alarmHexParse(id) {
  return get({
    url: '/tsp-jsatl/fms/jsatl/alarm/hex/parse/'+id,
    
  });
}

export function alarmAttachmentDown(params) {
  return post({
    url: '/tsp-jsatl/jsatl/alarmAttachment/down',
    data:params
  });
}
export function queryAttachmentList(params) {
  return get({
    url: '/tsp-jsatl/jsatl/alarmAttachment/queryAttachmentList',
    params
  });
}

export function queryCommondList(params) {
  return get({
    url: '/tsp-jsatl/jsatl/alarmAttachment/queryCommondList',
    params
  });
}

export function hexListExport(params) {
  return get({
    url: `/tsp-jsatl/fms/jsatl/alarm/hex/hexList/export`,
    params
  });
}
export function queryCommondListDetail(params) {
  return get({
    url: `/tsp-jsatl/jsatl/alarmAttachment/msgParse`,
    params
  });
}

export function getPhotoParams(params){
   return get({
     url: "/tsp-jsatl/jsatl/photo/photoParams",
     params
   })
}
